import { makeHttpRequest } from "@/shared";

import { mapCalculatedSellingFromServer } from "./mappers/mapCalculatedSellingFromServer";
export const removeClientFromSelling = async (sessionKey) => {
    const response = (
        await makeHttpRequest({
            url: `/stock/builder/${sessionKey}/remove/client`,
            method: "DELETE",
        })
    ).data;

    return mapCalculatedSellingFromServer(response.data);
};
